import React from "react";

export default function DeleteAccount() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-16 text-slate-800">
      <div className="mx-auto max-w-4xl rounded-[2rem] border border-slate-200 bg-white p-6 shadow-[0_20px_60px_rgba(15,23,42,0.08)] md:p-10">
        <div className="mb-8">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-orange-500">
            Account Deletion
          </p>
          <h1 className="text-3xl font-extrabold text-slate-900 md:text-5xl">
            Delete Your Hunt Share Live Account
          </h1>
        </div>

        <div className="space-y-6 text-base leading-8 text-slate-700">
          <p>
            Hunt Share Live allows users to request deletion of their account and associated personal data at any time.
          </p>

          <p>
            To request deletion of your Hunt Share Live account, please contact our support team using the contact information below:
          </p>

          <div className="rounded-2xl border border-orange-100 bg-orange-50 p-5">
            <p className="font-semibold text-slate-900">Email:</p>
            <a
              href="mailto:support@livehuntshare.com?subject=Account%20Deletion%20Request%20-%20Hunt%20Share%20Live"
              className="mt-2 inline-block text-lg font-semibold text-[#0B19B7] underline decoration-2 underline-offset-4"
            >
              support@livehuntshare.com
            </a>
          </div>

          <p>
            When submitting your request, please provide the email address, phone number, or username associated with your Hunt Share Live account so that we can verify and process your request.
          </p>

          <div>
            <h2 className="mb-3 text-2xl font-bold text-slate-900">What Happens When You Request Account Deletion?</h2>
            <p>After your request is verified:</p>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>Your Hunt Share Live account will be permanently deleted.</li>
              <li>Personal information associated with your account will be deleted where applicable.</li>
              <li>User profile information and account-related data will be removed.</li>
              <li>Access to your account and associated services will be terminated.</li>
              <li>Virtual items, virtual currency, earnings, or other account-related benefits may be lost and cannot be recovered after deletion.</li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-bold text-slate-900">Data That May Be Retained</h2>
            <p>
              Certain information may need to be retained for a limited period where required by law, for legal claims, fraud prevention, security, financial records, or other legitimate legal obligations.
            </p>
            <p className="mt-3">
              Any retained information will be handled securely and deleted when it is no longer required.
            </p>
          </div>

          <div className="rounded-2xl border border-red-100 bg-red-50 p-5">
            <h2 className="mb-2 text-xl font-bold text-slate-900">Important</h2>
            <p>
              Account deletion is permanent and cannot be undone. Once your account has been deleted, you may not be able to recover your account, messages, content, virtual items, or other account-related information.
            </p>
          </div>

          <p>
            For more information about how Hunt Share Live collects, uses, and protects your information, please refer to our Privacy Policy.
          </p>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
            <h2 className="mb-2 text-xl font-bold text-slate-900">Hunt Share Live Support</h2>
            <p>
              Email: <a href="mailto:support@livehuntshare.com" className="font-semibold text-[#0B19B7] underline">support@livehuntshare.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
